import React, { useState } from 'react';
import './SearchFilter.css';

const SearchFilter = ({ placeholder = 'Pesquisar...', onSearch }) => {
  const [searchValue, setSearchValue] = useState('');

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    onSearch(value);
  };

  const handleClear = () => {
    setSearchValue('');
    onSearch('');
  };

  return (
    <div className="search-filter">
      <span className="search-icon">🔍</span>
      <input
        type="text"
        className="search-input"
        placeholder={placeholder}
        value={searchValue}
        onChange={handleChange}
        aria-label="Pesquisar"
      />
      {searchValue && (
        <button
          className="search-clear"
          onClick={handleClear}
          aria-label="Limpar pesquisa"
          type="button"
        >
          ✕
        </button>
      )}
    </div>
  );
};

export default SearchFilter;
